/* import __COLOCATED_TEMPLATE__ from './unsaved-changes-dialog.hbs.js'; */
import templateOnlyComponent from '@ember/component/template-only';
export default templateOnlyComponent();